module Client.ConfirmReferral

open Fable.Core
open Fable.Import
open Elmish
open Fable.React
open Fable.React.Props
open Shared.Domain
open Style
open System
open Fable.Core.JsInterop
open Fetch
open Shared
open Elmish.Navigation

type Msg =
    | ReferralSent of SelfHelpPack: (string*string) list
    | GoToHome
    | FetchError of exn

type Model = 
    { 
        Id: Guid
        Waiting: bool
        SubmissionErrors: string list
        SelfHelpPack: (string*string) list
    }

let postReferralInfoCmd (tenant, id: Guid) = 
    let url = Urls.ConfirmReferral tenant
    FetchRequest.post url (id.ToString()) ReferralSent FetchError

let init tenant id = 
    {
        Id = id;
        Waiting = true;
        SubmissionErrors = []
        SelfHelpPack = []
    }, postReferralInfoCmd (tenant, id)

let update (msg:Msg) (model: Model) : Model*Cmd<Msg>* string option = 
    match msg with
    | GoToHome -> model, Navigation.newUrl (Pages.toHash Pages.Page.Home), None
    | ReferralSent pack ->
        { model with SelfHelpPack = pack; SubmissionErrors = []; Waiting = false }, [], Some "Your referral has been sent!" 
    | FetchError exn -> { model with SubmissionErrors = [exn.Message]; Waiting = false }, [], None   

let view (model: Model) (dispatch: Msg -> unit) =
    [
        div [ ClassName "container" ] [
            yield div [ 
                ClassName "centerflex" 
                Id "referral"
            ] [
                div [ 
                    ClassName "formstyle"
                ] [
                    if model.Waiting then
                        yield h2 [ ClassName "animated-background centerflex" ] [ str "Please wait..." ]
                        yield p [] [ str "We're checking your details now - please hold on..." ]
                    else
                        if model.SubmissionErrors.Length > 0 then
                            yield p [ ClassName "alert alert-danger" ] [
                                yield str "Unfortunately, we've had a problem sending your referral for the following reasons:"
                                for err in model.SubmissionErrors do
                                    yield str err
                                    yield br []
                            ]
                        else
                            yield h2 [] [ str "Referral Sent" ]
                            yield p [] [
                                str "Great, we've sent your referral. Someone should be in touch with you soon to guide you through the process. Of course, at busy times it may take a little longer than normal."
                            ]
                            if model.SelfHelpPack.Length > 0 then
                                yield strong [] [ str "Whilst you're waiting for a reply, please check out one of these initial help packs so you can familiarise yourself with the approach we will be taking together." ]
                                yield ul [ ClassName "list-group" ] [
                                    for item in model.SelfHelpPack do
                                        yield li [ ClassName "list-group-item" ] [ 
                                            a [ Href (snd item); Download (fst item) ] [ str (fst item) ]
                                        ]
                                ]
                           
                    yield button [ 
                        ClassName "btn btn-default"
                        HTMLAttr.Type "button"
                        OnClick (fun _ -> dispatch GoToHome)
                    ] [
                        str "Back to Home"
                    ]  
                ]
            ]
        ]
    ]
